export type SheetData = { headers: string[]; rows: string[][] }

/** Detects delimiter: semicolon when the first line has more `;` than `,`.
 *  Quoted spans are stripped before counting so embedded delimiters don't skew the result. */
function detectDelimiter(firstLine: string): string {
  const unquoted = firstLine.replace(/"[^"]*"/g, "")
  const commas = (unquoted.match(/,/g) ?? []).length
  const semis = (unquoted.match(/;/g) ?? []).length
  return semis > commas ? ";" : ","
}

export function parseCsv(raw: string): SheetData {
  const text = raw.replace(/\r\n|\r/g, "\n").trim()
  if (!text) return { headers: [], rows: [] }
  const delimiter = detectDelimiter(text.split("\n", 1)[0])

  const records: string[][] = []
  let field = ""
  let record: string[] = []
  let inQuotes = false
  for (let i = 0; i < text.length; i++) {
    const ch = text[i]
    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') {
        field += '"'
        i++
      } else if (ch === '"') {
        inQuotes = false
      } else {
        field += ch
      }
    } else if (ch === '"') {
      inQuotes = true
    } else if (ch === delimiter) {
      record.push(field)
      field = ""
    } else if (ch === "\n") {
      record.push(field)
      field = ""
      records.push(record)
      record = []
    } else {
      field += ch
    }
  }
  record.push(field)
  records.push(record)

  const nonEmpty = records.filter((r) => r.some((cell) => cell !== ""))
  if (nonEmpty.length === 0) return { headers: [], rows: [] }
  const [headers, ...rows] = nonEmpty
  const width = headers.length
  return {
    headers,
    rows: rows.map((r) => Array.from({ length: width }, (_, i) => r[i] ?? "")),
  }
}
